(() => {
	const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	// Stage backgrounds show a blurred placeholder until their image is in; the card images have transparent
	// edges, so the placeholder must go once the real pixels are there.
	document.querySelectorAll(".picco-stage__bg").forEach((picture) => {
		const img = picture.querySelector("img");
		if (!img) return;
		// Wait for decode too, so dropping the placeholder never leaves a blank frame.
		const done = () =>
			(img.decode ? img.decode() : Promise.resolve())
				.catch(() => {})
				.then(() => picture.classList.add("is-loaded"));
		if (img.complete && img.naturalWidth) done();
		else img.addEventListener("load", done, { once: true });
	});

	const slider = document.querySelector("[data-picco-showcase-slider]");
	if (slider && window.Swiper) {
		new Swiper(slider, {
			effect: "cards",
			grabCursor: true,
			rewind: true,
			speed: reduceMotion ? 0 : 500,
			// The card images have torn transparent edges; Swiper's rectangular shadow overlay would box them in.
			cardsEffect: {
				rotate: true,
				slideShadows: false,
			},
			navigation: {
				prevEl: "[data-picco-showcase-prev]",
				nextEl: "[data-picco-showcase-next]",
			},
			// Custom class names keep Swiper's default pagination CSS off the design's pill nav.
			pagination: {
				el: "[data-picco-showcase-pagination]",
				clickable: true,
				bulletElement: "button",
				bulletClass: "picco-showcase__bullet",
				bulletActiveClass: "is-active",
				modifierClass: "picco-showcase__pagination--",
				horizontalClass: "picco-showcase__pagination--horizontal",
			},
			// Swiper only fires click for taps, not drags; the front card is always the clicked one, so advance.
			on: {
				click: (swiper) => swiper.slideNext(),
			},
		});
	}

	const openSection = document.querySelector("[data-picco-open]");
	// Mobile is a single static composition; desktop and tablet share the switchable layout.
	// Click covers touch devices, which have no hover.
	if (openSection && window.matchMedia("(min-width: 751px)").matches) {
		const features = [...openSection.querySelectorAll("[data-picco-open-feature]")];
		const stamps = [...openSection.querySelectorAll(".picco-open__stamp")];

		const activate = (feature) => {
			const index = features.indexOf(feature);
			openSection.dataset.active = feature.dataset.piccoOpenFeature;
			features.forEach((item) => item.classList.toggle("is-active", item === feature));
			stamps.forEach((stamp, i) => stamp.classList.toggle("is-active", i === index));
		};

		features.forEach((feature) => {
			feature.addEventListener("mouseenter", () => activate(feature));
			feature.addEventListener("click", () => activate(feature));
		});
	}

	if (!window.gsap || !window.ScrollTrigger) return;
	gsap.registerPlugin(ScrollTrigger);

	// Mobile: pin the reading section under the sticky specs header and swap callout/arrow sets halfway through.
	const reading = document.querySelector("[data-picco-reading]");
	if (reading) {
		const specsHeader = document.querySelector(".product-specs__header");
		// The theme ships GSAP 3.10, which has ScrollTrigger.matchMedia but not gsap.matchMedia.
		ScrollTrigger.matchMedia({
			"(max-width: 750px)": () => {
				ScrollTrigger.create({
					trigger: reading,
					start: () => `top ${specsHeader ? specsHeader.offsetHeight : 0}px`,
					end: () => `+=${window.innerHeight}`,
					pin: true,
					pinSpacing: true,
					anticipatePin: 1,
					invalidateOnRefresh: true,
					onUpdate: (self) => reading.classList.toggle("is-state-2", self.progress > 0.5),
				});
				return () => reading.classList.remove("is-state-2");
			},
		});
	}

	if (reduceMotion) return;

	// Items trigger on their own position: on mobile a group's items can sit screens apart and out of DOM order
	// (e.g. the open features), so a single trigger on the first item would reveal them too early or too late.
	// Items that enter together are batched so they still stagger.
	document.querySelectorAll("[data-picco-reveal]").forEach((group) => {
		const items = group.querySelectorAll(
			":scope > *:not(.picco-open__feature):not(.visually-hidden), :scope > .picco-open__feature > *",
		);
		if (!items.length) return;

		gsap.set(items, { autoAlpha: 0, yPercent: 8 });
		ScrollTrigger.batch(items, {
			start: "top 75%",
			once: true,
			onEnter: (batch) =>
				gsap.to(batch, {
					autoAlpha: 1,
					yPercent: 0,
					duration: 0.75,
					stagger: 0.08,
					ease: "power2.out",
				}),
		});
	});
})();
